__turbopack_context__.v({
  "addToCartButtonContent": "yLFgUa_addToCartButtonContent",
  "addedToCartDisclaimer": "yLFgUa_addedToCartDisclaimer",
  "backdrop": "yLFgUa_backdrop",
  "baseAddToCartButton": "yLFgUa_baseAddToCartButton",
  "cardBottomSection": "yLFgUa_cardBottomSection",
  "cardTopSection": "yLFgUa_cardTopSection",
  "container": "yLFgUa_container",
  "content": "yLFgUa_content",
  "ctaContainer": "yLFgUa_ctaContainer",
  "description": "yLFgUa_description",
  "fadeIn": "yLFgUa_fadeIn",
  "fadeOut": "yLFgUa_fadeOut",
  "hidden": "yLFgUa_hidden",
  "imageContainer": "yLFgUa_imageContainer",
  "learnMoreLink": "yLFgUa_learnMoreLink",
  "priceContainer": "yLFgUa_priceContainer",
  "tag": "yLFgUa_tag",
  "title": "yLFgUa_title",
  "visible": "yLFgUa_visible",
});
